import React, { useEffect, useState } from "react";
import {
  Form,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Tabs,
  Tab,
  Dropdown,
} from "react-bootstrap";
import { acivityLog, useSetSatus, useUserInfo, userRoles } from "./store";
import {
  ROLES_NAME,
  allowRolesSuperAdmin,
  days,
  fourPlaceHolder,
  getCurrentUserRole,
  roles,
  CREATE_NEW_USER_EMAIL_ACCESS
} from "modules/utilities/utility";
import CreateNewUser from "./CreateUser";
import { Link } from "react-router-dom";
import PaginationComponent from "./PaginationComponent";
import LoginReport from "./LoginReport";
import DownloadCSV from "./DownloadCSV";
import { Checkbox, Select } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import CardDiv from "modules/common/card-div/CardDiv";
import GroupManagement from "pages/GroupManagement";
import secureLocalStorage from "react-secure-storage";
const { ADMIN } = ROLES_NAME;
import CallProviderManagement from "./CallProvider/CallProviderManagement";

function UserManagement() {
  const { fetchUserData, userData, isLoading } = useUserInfo();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeStatusFilter, setActiveStatusFilter] = useState("all");
  const [rolesFilter, setRolesFilter] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const currentUser = getCurrentUserRole();
  const { setUserStatus } = useSetSatus();
  const { activityLogs } = acivityLog();
  const curentUserRole = getCurrentUserRole();
  const [eventKey, setEventKey] = useState("");
  const { roleData, getUserRoles } = userRoles();
  useEffect(() => {
    getUserRoles();
  }, []);
  useEffect(() => {
    fetchUserData(currentUser);
  }, [currentUser]);

  useEffect(() => {
    if (userData) {
      setUsers(userData);
      setFilteredUsers(userData);
    }
  }, [userData]);

  const [users, setUsers] = useState([]);

  const handleStatusFilterChange = (value) => {
    setActiveStatusFilter(value);
  };

  const handleRoleSelect = (values) => {
    setRolesFilter(values);
    setCurrentPage(1);
  };

  const handleActiveStatusToggle = (userId) => {
    setUsers((prevUsers) => {
      const updatedUsers = prevUsers.map((user) =>
        user.user_id === userId
          ? { ...user, user: { ...user.user, is_active: !user.user.is_active } }
          : user
      );

      const updatedUser = updatedUsers.find((user) => user.user_id === userId);
      const updatedStatus = updatedUser?.user.is_active;

      const originalUserDetails = prevUsers.find(
        (user) => user.user_id === userId
      );

      const modifiedUserDetails = updatedUser.user;
      setUserStatus(updatedStatus, userId);

      activityLogs(userId, {
        authorName: secureLocalStorage.getItem("first_name"),
        original: originalUserDetails,
        modified: modifiedUserDetails,
      });

      return updatedUsers;
    });
  };

  const handleSearchQueryChange = (query) => {
    setSearchQuery(query);

    const filtered = users.filter(
      (user) =>
        user.user.first_name.toLowerCase().includes(query.toLowerCase()) ||
        user.user.phone_number.includes(query) ||
        user.user.email.includes(query)
    );
    setFilteredUsers(filtered);

    setCurrentPage(1);
  };

  const filteredUsersByStatus =
    activeStatusFilter === "all"
      ? filteredUsers
      : filteredUsers.filter((user) =>
          activeStatusFilter === "active"
            ? user.user.is_active
            : !user.user.is_active
        );

  const filteredUsersByRole =
    rolesFilter.length === 0
      ? filteredUsersByStatus
      : filteredUsersByStatus.filter((user) =>
          rolesFilter.includes(user.role_id)
        );

  const itemsPerPage = 10;
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;

  const currentUsers = Array.isArray(filteredUsersByRole)
    ? filteredUsersByRole.slice(indexOfFirstUser, indexOfLastUser)
    : [];
  const clearSelection = () => {
    setRolesFilter([]);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const totalPages =
    filteredUsersByRole.length > 0
      ? Math.ceil(filteredUsersByRole.length / itemsPerPage)
      : 0;

  const pageNumbers = [];
  if (currentPage < totalPages) {
    pageNumbers.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
      />
    );
    pageNumbers.push(
      <Pagination.Last
        key="last"
        onClick={() => handlePageChange(totalPages)}
      />
    );
  }
  return (
    <>
      <Tabs defaultActiveKey="user-mgmt" onSelect={setEventKey}>
        <Tab
          eventKey="user-mgmt"
          title="User management"
          className="border-bottom border-x"
        >
          <div className="tab-content">
            <CardDiv
              title={
                <div className="d-flex justify-content-between align-items-center ">
                  <div className="fs-2"> User Management </div>
                  <div className="d-flex align-items-center">
                    {((secureLocalStorage.getItem("level") == "5" ||
                      secureLocalStorage.getItem("level") == "1") && (![ADMIN].includes(currentUser))) && (
                      <CreateNewUser />
                    )}
                    {userData && <DownloadCSV data={userData} />}
                    <Form.Group controlId="search">
                      <Form.Control
                        type="text"
                        placeholder="Search by name or phone number"
                        value={searchQuery}
                        onChange={(event) =>
                          handleSearchQueryChange(event.target.value)
                        }
                      />
                    </Form.Group>
                    <div className="ms-2">
                      <Dropdown>
                        <Dropdown.Toggle variant="" id="statusFilterDropdown">
                          Status Filter
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleStatusFilterChange("all")}
                            active={activeStatusFilter === "all"}
                          >
                            All
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleStatusFilterChange("active")}
                            active={activeStatusFilter === "active"}
                          >
                            Activated
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleStatusFilterChange("inactive")}
                            active={activeStatusFilter === "inactive"}
                          >
                            Deactivated
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="ms-2">
                      <Select
                        mode="multiple"
                        placeholder="Select roles"
                        onChange={handleRoleSelect}
                        style={{ width: "170px" }}
                        optionFilterProp="label"
                        value={rolesFilter}
                        maxTagCount={0}
                        allowClear
                        showSearch
                      >
                        {roleData?.map((role) => (
                          <Option
                            key={role?.id}
                            label={role?.name}
                            value={role?.id}
                          >
                            <Checkbox
                              checked={rolesFilter?.includes(role?.id)}
                            />
                            <span className="ps-2">{role?.name}</span>
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              }
              component={
                <div id="userTab" className="tab-pane fade show active">
                  <table className="table">
                    <thead>
                      <tr className="border-bottom">
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Level</th>
                        <th>Active Status</th>
                        <th>Consult Doctor / Active</th>
                        <th>Break Days</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          {Array.from({ length: 8 }, (_, index) => (
                            <td key={index}>{fourPlaceHolder()}</td>
                          ))}
                        </tr>
                      ) : (
                        currentUsers?.map((user) => (
                          <tr key={user.id} className="border-bottom">
                            <td className="fw-bold">
                              <Link to={`/edit-user/${user.user_id}`}>
                                {user.user.first_name}
                              </Link>
                            </td>
                            <td>{user.user.phone_number}</td>
                            <td>{user.user.email}</td>
                            <td>{roles[user.role_id]}</td>
                            <td>{user.user.level}</td>
                            <td>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip_${user.user_id}`}
                                    style={{
                                      fontSize: "12px",
                                      maxWidth: "300px",
                                    }}
                                  >
                                    {`Are you sure you want to ${
                                      user.user.is_active
                                        ? "deactivate"
                                        : "activate"
                                    } this user? This will change their availability for slot calls`}
                                  </Tooltip>
                                }
                              >
                                <Form.Check
                                  type="switch"
                                  id={`checkedSwitch_${user.user_id}`}
                                  defaultChecked={user.user.is_active}
                                  label={
                                    user.user.is_active ? "Active" : "Inactive "
                                  }
                                  onChange={() =>
                                    handleActiveStatusToggle(user.user_id)
                                  }
                                  disabled={user.user.deactivated}
                                />
                              </OverlayTrigger>
                            </td>
                            <td>
                              {`${
                                user.user.is_consult_doctor ? "Yes" : "No"
                              } - ${
                                user.user.is_consult_doctor_active
                                  ? "Active"
                                  : "Inactive"
                              }`}
                            </td>
                            <td>
                              {user.user.meta.breakWeekDays
                                .map((dayIndex) => {
                                  return days[dayIndex];
                                })
                                .join(", ")}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-center">
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                      pagesToShow={5}
                    />
                  </div>
                </div>
              }
            />
          </div>
        </Tab>
        <Tab
          eventKey="group-management"
          title="Group Management"
          className="border-bottom border-x"
        >
          <GroupManagement />
        </Tab>
        {allowRolesSuperAdmin.includes(curentUserRole) && (
          <Tab
            eventKey="login-report"
            title="Login Report"
            className="border-bottom border-x p-3"
          >
            <LoginReport />
          </Tab>
        )}
        {allowRolesSuperAdmin.includes(curentUserRole) ? (
          <Tab eventKey="call-provider-mgmt" title="Call Provider Management">
            {eventKey === "call-provider-mgmt" ? (
              <CallProviderManagement eventKey={eventKey} />
            ) : null}
          </Tab>
        ) : null}
      </Tabs>
    </>
  );
}

export default UserManagement;
